import { compact } from 'lodash-es';
import { NO_STYLE_ID } from 'client/data/models/comparator';
import { VEHICLE_PATH_NAME } from 'site-modules/comparator/constants/comparator';
import { formatPriceString } from 'site-modules/shared/utils/price-utils';
import { parseVehicleParam } from 'client/utils/parse-vehicle-param';
import { getQuery } from 'client/utils/location';
import { hasTcoDataByYear } from 'site-modules/shared/utils/tco';
import { buildVehicleSubmodelStylePath } from 'client/data/models/vehicle-v2';

export function getColumnIdsString(columns, includeSubmodel) {
  return columns
    .map(
      ({ styleId, submodel, id }) =>
        (styleId && compact([styleId, includeSubmodel ? submodel : null]).join('|')) || id || NO_STYLE_ID
    )
    .join(',');
}

export function getTCOIdsString(styles) {
  return styles.map(style => (style && hasTcoDataByYear(style.year) && style.id) || NO_STYLE_ID).join(',');
}

export function getDisplayPriceValue(value) {
  return !value ? '-' : formatPriceString(value);
}

export function buildVehiclePath(location, index) {
  const { styleId, submodel } = parseVehicleParam(getQuery(location), `${VEHICLE_PATH_NAME}${index}`);
  return buildVehicleSubmodelStylePath({ styleId, submodel });
}

export function buildVehiclePathFromColumns(columns, index) {
  return buildVehicleSubmodelStylePath({ styleId: columns[index]?.styleId, submodel: columns[index]?.submodel });
}

// Split, remove first word, join, remove last char
export function parseType(string) {
  return string.split(' ').slice(1).join(' ').slice(0, -1);
}

export function hasFeatureValue(featureValue) {
  return !!featureValue && !['not available', '-', 'not applicable'].includes(featureValue.toLowerCase());
}
